import Moment from 'moment';

import { getDateFormat, getNow } from 'pages/utils/time';

export const getItemPrintedTimestamp = async () => {
  const dateFormat = await getDateFormat();
  const nowTimestamp = getNow().toString();
  return Moment(nowTimestamp).format(dateFormat);
};
